import { render, staticRenderFns } from "./mulUnitShow.vue?vue&type=template&id=5ca0d2f8&scoped=true&"
import script from "./mulUnitShow.vue?vue&type=script&lang=js&"
export * from "./mulUnitShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca0d2f8",
  null
  
)

export default component.exports